import { Toaster } from '@blueprintjs/core';

export const toaster = Toaster.create();
